(function () {
  'use strict';

  var bq = window.bq;
  if (!bq) return;

  function init(host) {
    if (!host || host.dataset.bqProfileInit) return;
    host.dataset.bqProfileInit = '1';

    // Goes straight into an href: https:// or a site-relative path only
    // (a lone '/' would still let '//host' through).
    var FALLBACK_URL = /^(https:\/\/|\/(?!\/))/.test(host.dataset.fallbackUrl || '')
      ? host.dataset.fallbackUrl
      : 'https://christine-mtc.fr';

    // Locale strings injected by the section (#bq-profile-i18n). French stays
    // embedded as fallback so a missing key never surfaces raw. Display only:
    // slug()/CSS classes keep the canonical French values.
    var I18N = {};
    try {
      var i18nEl = document.getElementById('bq-profile-i18n');
      if (i18nEl) I18N = JSON.parse(i18nEl.textContent || '{}');
    } catch (e) { I18N = {}; }
    function t(key, fallback) {
      var v = I18N[key];
      return (typeof v === 'string' && v && v.indexOf('Translation missing') === -1) ? v : fallback;
    }
    function mvtLabel(m) { return t('mvt_' + m, m); }

    var emptyEl    = document.getElementById('bq-profile-empty');
    var contentEl  = document.getElementById('bq-profile-content');
    var titleEl    = document.getElementById('bq-profile-title');
    var portraitEl = document.getElementById('bq-profile-portrait-text');
    var chipsEl    = document.getElementById('bq-profile-chips');
    var divergenceEl = document.getElementById('bq-profile-divergence');
    var confianceEl = document.getElementById('bq-profile-confiance');
    var productsEl = document.getElementById('bq-profile-products');
    var redoBtn = document.getElementById('bq-profile-redo');

    var profile = null;
    try {
      var raw = localStorage.getItem('botaqi_profile');
      if (raw) profile = JSON.parse(raw);
    } catch (e) { profile = null; }

    if (!profile || !profile.mouvement || !profile.filtres) {
      emptyEl.hidden = false;
      return;
    }

    contentEl.hidden = false;

    var ELEM_RGB = { 'Bois': '92 115 85', 'Feu': '176 83 58', 'Terre': '201 138 61', 'Métal': '141 147 132', 'Eau': '92 122 153' };
    var ELEM_CN = { 'Bois': '木', 'Feu': '火', 'Terre': '土', 'Métal': '金', 'Eau': '水' };

    (function ambiance() {
      var reduce = bq.reducedMotion();

      if (host && ELEM_RGB[profile.mouvement]) {
        host.style.setProperty('--bq-elem', ELEM_RGB[profile.mouvement]);
        host.classList.add('bq-profile--ambiance');

        if (!reduce) {
          var stamp = document.createElement('div');
          stamp.className = 'bq-profile__stamp';
          stamp.setAttribute('aria-hidden', 'true');
          var stampI = document.createElement('span');
          stampI.className = 'bq-profile__stamp-i';
          stampI.textContent = ELEM_CN[profile.mouvement] || '';
          stamp.appendChild(stampI);
          host.appendChild(stamp);
          var kill = function () { if (stamp.parentNode) stamp.parentNode.removeChild(stamp); };
          stamp.addEventListener('animationend', kill);
          setTimeout(kill, 2600); // fallback if animationend never fires
        }
      }
      contentEl.classList.add('is-reveal');
    })();

    portraitEl.innerHTML = portraitParas(profile.portrait || '')
      .map(function (p) { return '<p>' + colorizeMovements(pinyinHtml(p)) + '</p>'; })
      .join('');

    var glyphEl = document.getElementById('bq-profile-glyph');
    if (glyphEl) glyphEl.textContent = ELEM_CN[profile.mouvement] || '';

    var ENERGIE_LBL = {
      'Vide': t('energy_vide', 'À reconstituer'),
      'Plein': t('energy_plein', 'Débordante'),
      'Équilibré': t('energy_equilibre', 'Équilibrée')
    };

    function chipEl(value, mods) {
      var el = document.createElement('span');
      el.className = 'bq-profile-chip ' + mods.map(function (m) { return 'bq-profile-chip--' + m; }).join(' ');
      el.textContent = value;
      return el;
    }

    var rows = [];
    var mvtChips = [];
    if (profile.mouvement) mvtChips.push(chipEl(mvtLabel(profile.mouvement), ['movement', 'movement-' + bq.slug(profile.mouvement)]));
    if (profile.mouvement_secondaire) mvtChips.push(chipEl(mvtLabel(profile.mouvement_secondaire) + ' ' + t('support_suffix', '(appui)'), ['movement', 'movement-' + bq.slug(profile.mouvement_secondaire)]));
    if (mvtChips.length) rows.push({ lbl: t(mvtChips.length > 1 ? 'row_movements' : 'row_movement', mvtChips.length > 1 ? 'Mouvements' : 'Mouvement'), chips: mvtChips });
    if (profile.nature) rows.push({ lbl: t('row_nature', 'Nature'), chips: [chipEl(t('nat_' + profile.nature, profile.nature), ['nature', 'nature-' + bq.slug(profile.nature)])] });
    if (Array.isArray(profile.saveurs) && profile.saveurs.length) {
      rows.push({
        lbl: t(profile.saveurs.length > 1 ? 'row_flavours' : 'row_flavour', profile.saveurs.length > 1 ? 'Saveurs' : 'Saveur'),
        chips: profile.saveurs.map(function (sv) { return chipEl(t('sav_' + sv, sv), ['flavor', 'flavor-' + bq.slug(sv)]); })
      });
    }
    if (profile.vide_plein) rows.push({ lbl: t('row_energy', 'Énergie'), chips: [chipEl(ENERGIE_LBL[profile.vide_plein] || profile.vide_plein, ['energy'])] });

    var chipIndex = 0;
    rows.forEach(function (row) {
      var r = document.createElement('div');
      r.className = 'bq-profile__row';
      var l = document.createElement('span');
      l.className = 'bq-profile__row-lbl';
      l.textContent = row.lbl;
      r.appendChild(l);
      var cwrap = document.createElement('div');
      cwrap.className = 'bq-profile__row-chips';
      row.chips.forEach(function (c) {
        c.style.setProperty('--i', chipIndex++);
        cwrap.appendChild(c);
      });
      r.appendChild(cwrap);
      chipsEl.appendChild(r);
    });

    if (profile.divergence_constitution_moment && profile.constitution && profile.constitution !== profile.mouvement) {
      var consCn = movementCn(profile.constitution, profile.constitution_chinoise);
      var d = t('divergence', 'Lecture nuancée : votre constitution de fond est {constitution} {cn}. Vous traversez en ce moment une saison {mouvement}.')
        .replace('{constitution}', profile.constitution)
        .replace('{cn}', consCn ? '(' + consCn + ')' : '')
        .replace('{mouvement}', profile.mouvement)
        .replace(/\s{2,}/g, ' ');
      divergenceEl.innerHTML = colorizeMovements(pinyinHtml(d));
      divergenceEl.hidden = false;
    }

    if (typeof profile.confiance === 'number') {
      if (profile.confiance < 0.6) {
        confianceEl.innerHTML = t('confidence_low', 'Lecture incertaine. Pour aller plus loin, l\'avis d\'un praticien certifié sera plus précis :') + ' <a href="' + bq.escapeHTML(FALLBACK_URL) + '" rel="noopener" target="_blank">christine-mtc.fr</a>.';
        confianceEl.classList.add('bq-profile__confiance--low');
        confianceEl.hidden = false;
      } else if (profile.confiance < 0.8) {
        confianceEl.textContent = t('confidence_mid', 'Cette lecture peut s\'affiner avec un praticien certifié.');
        confianceEl.classList.add('bq-profile__confiance--mid');
        confianceEl.hidden = false;
      }
    }

    loadProducts(profile.filtres);

    if (redoBtn) {
      redoBtn.addEventListener('click', function () {
        try {
          localStorage.removeItem('botaqi_profile');
          localStorage.removeItem('botaqi_profile_date');
          sessionStorage.removeItem('botaqi_orienteur_session');
        } catch (e) {}
        location.reload();
      });
    }

    function buildFilterParams(filtres) {
      var p = new URLSearchParams();
      if (Array.isArray(filtres.movements)) {
        filtres.movements.forEach(function (m) { p.append('filter.p.m.tcm.movements', m); });
      }
      if (Array.isArray(filtres.thermal_nature)) {
        filtres.thermal_nature.forEach(function (n) { p.append('filter.p.m.tcm.thermal_nature', n); });
      }
      if (Array.isArray(filtres.flavors)) {
        filtres.flavors.forEach(function (f) { p.append('filter.p.m.tcm.flavors', f); });
      }
      if (Array.isArray(filtres.category)) {
        filtres.category.forEach(function (c) { p.append('filter.p.m.tcm.category', c); });
      }
      return p;
    }

    // Progressive filter relaxation: narrowest to broadest, to avoid zero results.
    async function loadProducts(f) {
      var has = function (x) { return Array.isArray(x) && x.length; };
      var levels = [];
      if (has(f.category)) {
        levels.push({ movements: f.movements, category: f.category, thermal_nature: f.thermal_nature, flavors: f.flavors });
        levels.push({ movements: f.movements, category: f.category, thermal_nature: f.thermal_nature });
        levels.push({ movements: f.movements, category: f.category });
      }
      levels.push({ movements: f.movements, thermal_nature: f.thermal_nature, flavors: f.flavors });
      levels.push({ movements: f.movements, thermal_nature: f.thermal_nature });
      levels.push({ movements: f.movements });

      var seenQs = {}, jobs = [];
      for (var i = 0; i < levels.length; i++) {
        var params = buildFilterParams(levels[i]);
        var qs = params.toString();
        if (!qs || seenQs[qs]) continue;
        seenQs[qs] = true;
        jobs.push({ level: levels[i], promise: fetchProducts(params) });
      }
      var results = await Promise.all(jobs.map(function (j) { return j.promise; }));

      var seen = {}, fine = [], broad = [];
      for (var r = 0; r < results.length; r++) {
        var isFine = has(jobs[r].level.category) || (!has(f.category) && r === 0);
        var items = results[r] || [];
        for (var j = 0; j < items.length; j++) {
          var k = productKey(items[j]);
          if (k && !seen[k]) {
            seen[k] = true;
            (isFine ? fine : broad).push(items[j]);
          }
        }
      }

      if (!fine.length && !broad.length) {
        productsEl.innerHTML = '<p class="bq-profile__empty-products">' + t('no_products', 'Aucun produit ne correspond pour le moment : refaites une lecture, ou explorez la boutique depuis le menu.') + '</p>';
        return;
      }
      renderProducts(fine, broad);
    }

    function productKey(item) {
      var a = item.querySelector('a[href*="/products/"]');
      if (a) return (a.getAttribute('href') || '').split('?')[0];
      return (item.textContent || '').trim().slice(0, 60);
    }

    function gridItems(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return Array.from(doc.querySelectorAll('.product-grid__item'));
    }

    // Dedicated lightweight section (cards only, no filters UI or scripts). A 200
    // is authoritative for this filter, even with zero items, so it never pulls
    // the heavy full page. The full page is a fallback only when the section is
    // unavailable (e.g. not yet deployed).
    async function fetchProducts(params) {
      // Locale prefix: unprefixed, the cards came back in the shop's primary
      // language on every other market.
      var url = bq.root(host) + 'collections/all?';
      var sectioned = new URLSearchParams(params);
      sectioned.set('section_id', 'bq-profile-results');
      try {
        var res = await fetch(url + sectioned.toString(), { headers: { 'accept': 'text/html' } });
        if (res.ok) return gridItems(await res.text());
      } catch (e) {}
      try {
        var full = await fetch(url + params.toString(), { headers: { 'accept': 'text/html' } });
        if (full.ok) return gridItems(await full.text());
      } catch (e) {}
      return [];
    }

    function renderProducts(fine, broad) {
      productsEl.innerHTML = '';
      var both = fine.length && broad.length;
      if (fine.length) {
        if (both) productsEl.appendChild(subTitle(t('best_match', 'Ce qui vous correspond le mieux')));
        renderGrid(fine);
      }
      if (broad.length) {
        if (both) productsEl.appendChild(subTitle(t('around_movement', 'Autour de votre Mouvement')));
        renderGrid(broad);
      }
    }

    function subTitle(txt) {
      var h = document.createElement('h3');
      h.className = 'bq-profile__subsection';
      h.textContent = txt;
      return h;
    }

    function renderGrid(items) {
      var ul = document.createElement('ul');
      ul.className = 'bq-profile__grid';
      productsEl.appendChild(ul);

      var BATCH = 8;
      var idx = 0;
      function appendBatch() {
        var end = Math.min(idx + BATCH, items.length);
        var base = idx;
        for (; idx < end; idx++) {
          var li = document.createElement('li');
          li.className = 'bq-profile__grid-item';
          li.style.setProperty('--i', idx - base);
          li.appendChild(items[idx].cloneNode(true));
          ul.appendChild(li);
        }
      }
      appendBatch();

      if (idx >= items.length) return;

      var sentinel = document.createElement('div');
      sentinel.className = 'bq-profile__sentinel';
      productsEl.appendChild(sentinel);

      if (!('IntersectionObserver' in window)) {
        while (idx < items.length) appendBatch();
        sentinel.remove();
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.unobserve(sentinel);
        appendBatch();
        if (idx >= items.length) { io.disconnect(); sentinel.remove(); return; }
        io.observe(sentinel);
      }, { rootMargin: '600px 0px' });
      io.observe(sentinel);
    }

    // Canonical pinyin per Movement: overrides the model text, whose tones are sometimes malformed.
    function movementCn(mouvement, fallback) {
      var MAP = { 'Bois': '木 Mù', 'Feu': '火 Huǒ', 'Terre': '土 Tǔ', 'Métal': '金 Jīn', 'Eau': '水 Shuǐ' };
      return MAP[mouvement] || bq.fixPinyin(fallback || '');
    }

    function pinyinHtml(s) {
      return bq.wrapPinyin(bq.escapeHTML(bq.fixPinyin(s || '')));
    }

    // Operates on already-escaped HTML; the .bq-pinyin annotation is included in the bold.
    function colorizeMovements(html) {
      return String(html).replace(
        /(^|[^\w>])(Bois|Feu|Terre|Métal|Eau)\b(\s*<span class="bq-pinyin">[^<]*<\/span>)?/g,
        function (_, pre, m, annot) {
          return pre + '<strong class="bq-mvt bq-mvt--' + bq.slug(m) + '">' + m + (annot || '') + '</strong>';
        }
      );
    }

    // One paragraph per sentence.
    function portraitParas(text) {
      var parts = String(text || '').match(/[^.!?…]+[.!?…]+(?:\s*[»")\]]+)?/g);
      if (!parts || parts.length < 2) return [String(text || '')];
      return parts.map(function (p) { return p.trim(); }).filter(Boolean);
    }
  }

  document.querySelectorAll('.bq-profile').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.bq-profile').forEach(init);
  });
})();
